<app-input-label *ngIf="!noLabel" [inputId]="id" [inputName]="name" [mandatory]="mandatory" [helpTooltipText]="helpTooltipText"></app-input-label>

<input
  [id]="id"
  [name]="name"
  class="input"
  [class.invalid]="isInvalid"
  type="text"
  [placeholder]="placeholder || ''"
  [maxlength]="maxLength"
  [disabled]="isDisabled"
  [mask]="inputMask || ''"
  [autofocus]="inputAutofocus"
  inputmode="numeric"
  [pattern]="pattern"
  [decimal]="allowDecimals"
  [decimalSeparator]="decimalSeparator"
  digitOnly
  [appAutofocus]="autofocus"
  [(ngModel)]="value"
  (blur)="onTouched($event)"
  (input)="handleInput()"

>
